import { useMutation, useQueryClient } from '@tanstack/react-query'

import { updateCustomGeneratedBriefDescription } from '../api'
import { contentKeys } from '../queryKeys'

const useUpdateCustomGeneratedBriefDescriptionMutation = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: updateCustomGeneratedBriefDescription,
    onSuccess: (content) => {
      queryClient.setQueryData(contentKeys.content(content._id), content)
    },
  })
}

export default useUpdateCustomGeneratedBriefDescriptionMutation
